(function () {
  'use strict';

  const CARD_SELECTOR = '.women-spot-product-card';
  const WISHLIST_KEY = 'womenSpotWishlist';

  function getCard(element) {
    return element
      ? element.closest(CARD_SELECTOR)
      : null;
  }

  function getVariantInput(card) {
    return card
      ? card.querySelector(
          '[data-women-spot-variant-input]'
        )
      : null;
  }

  function getErrorBox(card) {
    return card
      ? card.querySelector(
          '.women-spot-cart-error-message'
        )
      : null;
  }

  function clearError(card) {
    const errorBox = getErrorBox(card);

    if (!errorBox) return;

    errorBox.textContent = '';
    errorBox.hidden = true;
  }

  function showError(card, message) {
    const errorBox = getErrorBox(card);

    if (!errorBox) return;

    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function getSelectedVariantId(card) {
    const variantInput = getVariantInput(card);

    const variantId = Number.parseInt(
      variantInput ? variantInput.value : '',
      10
    );

    if (
      Number.isInteger(variantId) &&
      variantId > 0
    ) {
      return variantId;
    }

    return null;
  }

  function validateVariant(card) {
    const variantId = getSelectedVariantId(card);

    if (variantId) {
      return variantId;
    }

    const requiresSize =
      card &&
      card.dataset.requiresSize === 'true';

    if (requiresSize) {
      showError(
        card,
        'Please select an available size first.'
      );
    } else {
      showError(
        card,
        'This product is currently unavailable.'
      );
    }

    const sizeSection = card
      ? card.querySelector(
          '.women-spot-sizes-fieldset'
        )
      : null;

    if (sizeSection) {
      sizeSection.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }

    return null;
  }

  function updateDisplayedPrice(
    card,
    sizeButton
  ) {
    const priceRow = card.querySelector(
      '[data-women-spot-price-row]'
    );

    const salePrice = card.querySelector(
      '[data-women-spot-sale-price]'
    );

    let comparePrice = card.querySelector(
      '[data-women-spot-compare-price]'
    );

    const savingLabel = card.querySelector(
      '.women-spot-price-saving'
    );

    if (!priceRow || !salePrice) return;

    const newPrice =
      sizeButton.dataset.variantPrice
        ? sizeButton.dataset.variantPrice.trim()
        : '';

    const newComparePrice =
      sizeButton.dataset.variantComparePrice
        ? sizeButton.dataset.variantComparePrice.trim()
        : '';

    if (newPrice) {
      salePrice.textContent = newPrice;
    }

    if (newComparePrice) {
      if (!comparePrice) {
        comparePrice =
          document.createElement('s');

        comparePrice.className =
          'women-spot-price-compare';

        comparePrice.setAttribute(
          'data-women-spot-compare-price',
          ''
        );

        salePrice.insertAdjacentElement(
          'afterend',
          comparePrice
        );
      }

      comparePrice.textContent =
        newComparePrice;

      comparePrice.hidden = false;
    } else if (comparePrice) {
      comparePrice.textContent = '';
      comparePrice.hidden = true;
    }

    if (savingLabel) {
      savingLabel.hidden = true;
    }
  }

window.womenspotSelectSize = function (sizeButton) {
  const card = getCard(sizeButton);

  const isAvailable =
    String(
      sizeButton.dataset.variantAvailable || ''
    ).trim() === 'true';

  if (
    !card ||
    sizeButton.disabled ||
    !isAvailable
  ) {
    return;
  }

  const variantId = String(
    sizeButton.dataset.variantId || ''
  ).trim();

  const variantInput =
    getVariantInput(card);

  if (!variantId || !variantInput) {
    showError(
      card,
      'This size is currently unavailable.'
    );

    return;
  }

  /*
   * सर्व product cards मधील
   * जुने pink selections काढणे.
   */
  document
    .querySelectorAll(CARD_SELECTOR)
    .forEach(function (productCard) {
      productCard
        .querySelectorAll(
          '.women-spot-size-badge'
        )
        .forEach(function (button) {
          button.classList.remove(
            'is-selected',
            'selected',
            'active'
          );

          button.setAttribute(
            'aria-pressed',
            'false'
          );
        });

      if (productCard !== card) {
        const oldVariantInput =
          getVariantInput(productCard);

        if (oldVariantInput) {
          oldVariantInput.value = '';
        }

        delete productCard.dataset
          .selectedVariant;

        clearError(productCard);
      }
    });

  /*
   * फक्त आताच click केलेला size pink करा.
   */
  sizeButton.classList.add(
    'is-selected',
    'selected',
    'active'
  );

  sizeButton.setAttribute(
    'aria-pressed',
    'true'
  );

  variantInput.value = variantId;

  card.dataset.selectedVariant =
    variantId;

  updateDisplayedPrice(
    card,
    sizeButton
  );

  clearError(card);
};
  function setCardLoading(
    card,
    loading,
    activeButton
  ) {
    if (!card) return;

    card.setAttribute(
      'aria-busy',
      String(loading)
    );

    card
      .querySelectorAll(
        '.women-spot-btn'
      )
      .forEach(function (button) {
        if (loading) {
          button.dataset.originalHtml =
            button.innerHTML;

          button.disabled = true;

          if (button === activeButton) {
            button.textContent =
              'Please wait...';
          }
        } else {
          if (
            button.dataset.originalHtml
          ) {
            button.innerHTML =
              button.dataset.originalHtml;

            delete button.dataset
              .originalHtml;
          }

          button.disabled =
            card.classList.contains(
              'women-spot-product-card--sold-out'
            );
        }
      });
  }
  

  function updateCustomCartBubble(
    itemCount
  ) {
    const cartLink =
      document.querySelector(
        '#women-spot-cart-icon'
      );

    if (!cartLink) return;

    let bubble = cartLink.querySelector(
      '.women-spot-cart-count-bubble'
    );

    if (itemCount <= 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble =
        document.createElement('span');

      bubble.className =
        'women-spot-cart-count-bubble';

      cartLink.appendChild(bubble);
    }

    bubble.textContent =
      itemCount > 99
        ? '99+'
        : String(itemCount);
  }

  async function refreshCartCount() {
    try {
      const root =
        window.Shopify &&
        window.Shopify.routes
          ? window.Shopify.routes.root
          : '/';

      const response = await fetch(
        root + 'cart.js',
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) return;

      const cart = await response.json();

      updateCustomCartBubble(
        cart.item_count || 0
      );
    } catch (error) {
      console.warn(
        'Cart count could not be refreshed.',
        error
      );
    }
  }

  async function addVariantToCart(
    variantId
  ) {
    const root =
      window.Shopify &&
      window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );

    let sectionIds = [
      'cart-drawer',
      'cart-icon-bubble'
    ];

    if (
      cartDrawer &&
      typeof cartDrawer
        .getSectionsToRender ===
        'function'
    ) {
      sectionIds = cartDrawer
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        });
    }

    const response = await fetch(
      root + 'cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',
          Accept: 'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ],
          sections: sectionIds,
          sections_url:
            window.location.pathname
        })
      }
    );

    const result =
      await response.json();

    if (
      !response.ok ||
      result.status
    ) {
      throw new Error(
        result.description ||
        result.message ||
        'Unable to add this product.'
      );
    }

    if (
      cartDrawer &&
      typeof cartDrawer
        .renderContents ===
        'function' &&
      result.sections
    ) {
      cartDrawer.renderContents(
        result
      );
    }

    await refreshCartCount();

    if (
      cartDrawer &&
      typeof cartDrawer.open ===
        'function'
    ) {
      window.setTimeout(
        function () {
          cartDrawer.open();
        },
        80
      );
    } else if (cartDrawer) {
      cartDrawer.classList.add(
        'active',
        'is-active'
      );
    }

    return result;
  }

  window.womenspotAddToCart =
    async function (button) {
      const card = getCard(button);

      const variantId =
        validateVariant(card);

      if (!card || !variantId) {
        return;
      }

      clearError(card);

      setCardLoading(
        card,
        true,
        button
      );

      try {
        await addVariantToCart(
          variantId
        );

        button.textContent = 'Added!';

        window.setTimeout(
          function () {
            setCardLoading(
              card,
              false,
              button
            );
          },
          900
        );
      } catch (error) {
        setCardLoading(
          card,
          false,
          button
        );

        showError(
          card,
          error.message ||
          'Something went wrong. Please try again.'
        );
      }
    };

  window.womenspotBuyNow = function (
    button
  ) {
    const card = getCard(button);

    const variantId =
      validateVariant(card);

    if (!card || !variantId) {
      return;
    }

    clearError(card);

    setCardLoading(
      card,
      true,
      button
    );

    const root =
      window.Shopify &&
      window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    window.location.href =
      root +
      'cart/' +
      variantId +
      ':1?checkout';
  };

  function readWishlist() {
    try {
      const stored =
        window.localStorage.getItem(
          WISHLIST_KEY
        );

      const wishlist = JSON.parse(
        stored || '[]'
      );

      if (!Array.isArray(wishlist)) {
        return [];
      }

      return wishlist.map(String);
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      window.localStorage.setItem(
        WISHLIST_KEY,
        JSON.stringify(items)
      );
    } catch (error) {
      console.warn(
        'Wishlist could not be saved.',
        error
      );
    }
  }

  function updateWishlistButton(
    button,
    active
  ) {
    button.classList.toggle(
      'is-active',
      active
    );

    button.setAttribute(
      'aria-pressed',
      String(active)
    );

    const card = getCard(button);

    const productTitleElement =
      card
        ? card.querySelector(
            '.women-spot-product-title'
          )
        : null;

    const productTitle =
      productTitleElement
        ? productTitleElement
            .textContent.trim()
        : 'product';

    if (active) {
      button.setAttribute(
        'aria-label',
        'Remove ' +
          productTitle +
          ' from wishlist'
      );
    } else {
      button.setAttribute(
        'aria-label',
        'Add ' +
          productTitle +
          ' to wishlist'
      );
    }
  }

  function initializeWishlist(
    root
  ) {
    const currentRoot =
      root || document;

    const wishlist =
      readWishlist();

    currentRoot
      .querySelectorAll(
        '[data-women-spot-wishlist]'
      )
      .forEach(function (button) {
        if (
          button.dataset
            .wishlistInitialized ===
          'true'
        ) {
          return;
        }

        button.dataset
          .wishlistInitialized =
          'true';

        const productId = String(
          button.dataset.productId ||
          ''
        );

        updateWishlistButton(
          button,
          wishlist.includes(productId)
        );

        button.addEventListener(
          'click',
          function () {
            const savedItems =
              readWishlist();

            const isSaved =
              savedItems.includes(
                productId
              );

            let updatedItems;

            if (isSaved) {
              updatedItems =
                savedItems.filter(
                  function (id) {
                    return (
                      id !== productId
                    );
                  }
                );
            } else {
              updatedItems =
                savedItems.concat(
                  productId
                );
            }

            saveWishlist(
              updatedItems
            );

            updateWishlistButton(
              button,
              !isSaved
            );

            document.dispatchEvent(
              new CustomEvent(
                'womenSpot:wishlistChange',
                {
                  detail: {
                    productId:
                      productId,
                    saved: !isSaved,
                    items:
                      updatedItems
                  }
                }
              )
            );
          }
        );
      });
  }

  function initializeProductGrid(
    root
  ) {
    initializeWishlist(
      root || document
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeProductGrid(
          document
        );
      }
    );
  } else {
    initializeProductGrid(
      document
    );
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeProductGrid(
        event.target
      );
    }
  );
})();
/* Collection-only filter dropdown behaviour */

document.addEventListener('click', function (event) {
  const clickedDropdown = event.target.closest(
    '[data-wsp-filter-dropdown]'
  );

  document
    .querySelectorAll('[data-wsp-filter-dropdown][open]')
    .forEach(function (dropdown) {
      if (dropdown !== clickedDropdown) {
        dropdown.removeAttribute('open');
      }
    });
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document
    .querySelectorAll('[data-wsp-filter-dropdown][open]')
    .forEach(function (dropdown) {
      dropdown.removeAttribute('open');
    });
});